import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Pie } from 'react-chartjs-2';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { Chart, Legend, LinearScale, Tooltip, CategoryScale, ArcElement } from 'chart.js';
import { NoDecimalsTooltipLabel } from '@/shared/utils/chartjsHelpers';
import { injectStateService, StateService } from '@/shared/services/StateService';
import messages from '../dashboardMessages';

Chart.register(Legend, LinearScale, Tooltip, CategoryScale, ArcElement);

const PeppolActivationStatusChart = ({ intl, stateService, companyId, data: rawData }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const { active, unsupportedFormat, notFound, notLookedUp } = rawData;
    if (active >= 0 || unsupportedFormat >= 0 || notFound >= 0 || notLookedUp >= 0) {
      const statuses = [0, 1, 3].map(x =>
        intl.formatMessage(listItemMsg('relationpeppolstatus', x)),
      );
      statuses.splice(2, 0, intl.formatMessage(messages.IncompatibleUblFormat)); // shorter version of the normal status
      setChartData({
        labels: statuses,
        datasets: [
          {
            data: [notLookedUp, notFound, unsupportedFormat, active],
            backgroundColor: ['#797390', '#B80016', '#F0A800', '#00B295'],
            hoverBackgroundColor: ['#797390', '#a60014', '#d89700', '#00a086'],
            borderColor: '#ffffff',
            hoverBorderColor: '#ffffff',
            borderWidth: 0.5,
          },
        ],
      });
    }
  }, [rawData, intl]);

  const chartOptions = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: 'right',
        align: 'left',
      },
      tooltip: {
        enabled: true,
        mode: 'index',
        displayColors: false,
        callbacks: {
          label: context => {
            return NoDecimalsTooltipLabel(
              context,
              intl.formatMessage(messages.Customers).toLowerCase(),
            );
          },
        },
      },
    },
    events: ['click', 'mousemove'], // this is needed, otherwise onHover is not fired
    onHover: (event, chartElement) => {
      // eslint-disable-next-line no-param-reassign
      event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    onClick: (event, chartElements) => {
      const [element] = chartElements || [];
      if (!element) return;

      const peppolStatus = element.index;
      stateService.gotoRelationOverview({
        isPeppolRequired: true,
        peppolStatus: [peppolStatus],
        ownCompanies: [companyId],
      });
    },
  };
  return !chartData ? null : <Pie data={chartData} options={chartOptions} />;
};

PeppolActivationStatusChart.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.shape({}).isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
};

export default injectStateService(injectIntl(PeppolActivationStatusChart));
